























































































































import { Component, Vue } from 'vue-property-decorator';
import { getRr, putRr } from '@/api/setting';
import { RrSettingDataType } from '../../../common/dist/common';

@Component
export default class Setting extends Vue {
  public valid = true;
  public data: Partial<RrSettingDataType> = {};
  public submitting = false;
  public success = false;
  public error = false;

  public mounted() {
    this.load();
  }

  public async onRegist() {
    this.submitting = true;
    const ret = await putRr(this.data);
    if (ret.success) {
      this.success = true;
    } else {
      this.error = true;
    }
    this.submitting = false;
  }

  private async load() {
    const ret = await getRr();
    if (ret.success) {
      this.data = ret.data;
    }
  }
}
